import { trpc } from '../../../utils/trpc';

export function useAddPurchase() {
  const { data, mutateAsync } = trpc.purchase.create.useMutation();
  return {
    result: data,
    createPurchase: mutateAsync,
  };
}
